import { render, staticRenderFns } from "./StockMovementViewDetails.vue?vue&type=template&id=51c4edba"
import script from "./StockMovementViewDetails.vue?vue&type=script&lang=js"
export * from "./StockMovementViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports